import React, { useCallback, useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Avatar from '@mui/material/Avatar';
import '../medicine.css';
import { medicinecategory } from '../service';
import useMedicineLayoutStore from '../medicine.zustandstore';

function MedicineCategories() {
	const [medicineCategoryList, setMedicineCategoryList] = useState([]);
	const { setSelectedCategory, fetchMedicines } = useMedicineLayoutStore();

	const getMedicineCategoryList = useCallback(async () => {
		try {
			const res = await medicinecategory();
			const transformed = res.data.map((item, index) => ({
				...item,
				index: index + 1,
			}));
			setMedicineCategoryList(transformed);
		} catch (error) {
			console.error(error);
			setMedicineCategoryList([]);
		}
	}, []);

	useEffect(() => {
		getMedicineCategoryList();
	}, [getMedicineCategoryList]);

	const handleSelect = (id) => {
		setSelectedCategory(id);
		fetchMedicines(1); // Reset to page 1 on category change
	};

	return (
		<Container className='doc-cat-content'>
			<Grid container spacing={2}>
				{medicineCategoryList?.map((item, index) => {
					return (
						<Grid item xs={12} sm={3} key={'dept-' + index}>
							<Box
								className='doc-category'
								onClick = {() => handleSelect(item.id)}
							>
								<Avatar
									sx={{ width: 40, height: 40 }}
									alt='Bariatric Surgery'
									src={item.image}
									variant='square'
								/>
								<Typography className='small-black-txt'>
									{item.name}
								</Typography>
							</Box>
						</Grid>
					);
				})}
			</Grid>
		</Container>
	);
}

// MedicineCategories.propTypes = {
// 	onCategoryListFetch: PropTypes.func.isRequired,
// };

export default MedicineCategories;
